@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.repeat-icon {
  width: 16px;
  height: 16px;
  padding: 7px;
}

.button {
  color: @fulfillment-planner--rate-refresh--text-color;
  &:focus {
    * {
      color: @fulfillment-planner--rate-refresh-button--focus--text-color;
    }
  }
  &:enabled {
    &:hover {
      color: @fulfillment-planner--rate-refresh--hover--text-color;
    }
  }
  &:disabled {
    cursor: not-allowed;
    color: var(--default--icon--disabled--fill-color--1);
  }
}
